

































import { DeliveryProcedurePlugin } from '@/models/firmware/models';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'builtin-download-local',
  props: {
    plugin: {
      required: true,
    },
  },
  data() {
    return {};
  },
})
export default class DownloadLocal extends Vue {
  plugin: DeliveryProcedurePlugin;

  mounted() {
    this.plugin = this.$props.plugin;
  }
}
